export default __webpack_public_path__ + "static/media/sql.26122300.png";